import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_5c9kfmd3ra: FaireCollectionEntity = {
  token: "pbc_5c9kfmd3ra",
  type: "collection",
  name: "Pre-Order FW26 Joyful Days - Organic Woven",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3dc11d5144e584176ed4f019c44297057655464d0d325f6cc2b99273647f4701.jpeg",
  itemCount: 22,
  description:
    "Joyful Days is a celebration of childhood moments—soft laughter, curious hands, and days that unfold slowly. Crafted from certified organic woven cotton, this FW26 collection features enchanting floral prints, delicate embroideries, and timeless smocking.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:16.860Z",
    importedBy: "entity-db-import-collections",
  },
};
